import React from 'react';
import { Table, Tr, Td, Thead, Th } from 'reactable';

import DiversionModal from './DiversionModal';

const columnsByType = ['Country', 'numberInternationalIncidents', 'Additional Details'] ;

class DiversionTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      modalContent: ''
    };

    this.handleDescriptionClick = this.handleDescriptionClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleDescriptionClick(content) {
    return () => {
      this.setState({
        modalOpen: true,
        modalContent: content
      });
    }
  }

  handleCloseModal() {
    this.setState({
      modalOpen: false,
      modalContent: ''
    });
  }

  renderThead() {
    const columns = ['Country', 'Number of Incidents', 'Additional Details'];

    return columns.map((column, index) => {
      return (
        <Th key={ index } column={ column }>
          { column }
        </Th>
      );
    });
  }

  renderTds(rowData, country) {
    let content = [
        <Td key="Country" column="Country">
           {country}
        </Td>,
        <Td key='Number of Incidents' column='Number of Incidents'>
          { rowData[this.props.number] }
        </Td>,
        <Td key='Additional Details' column='Additional Details'>
          <a onClick={ this.handleDescriptionClick(rowData[this.props.description]) }>
            [Click for additional details]
          </a>
        </Td>
    ];
    return content.map(value => (value));
  }

  renderTrs() {
    const data = this.props.data;
    return Object.entries(data).map((entry) => {
      const [key, value] = entry;
      if (value[this.props.hasItem] == "5" || value[this.props.hasItem] == "Y") {
        return (<Tr>{ this.renderTds(value, key) }</Tr>)
      }
    });
  }

  renderNoData() {
    const type = this.props.type;

    return (
      <div className="no-needs-message">
        No { type } incidents reported
      </div>
    );
  }

  render() {
    const data = this.props.data,
      { modalOpen, modalContent } = this.state;

    if (!data || data.length === 0) return this.renderNoData();

    return (
      <div className="oecd-table__container">
        <Table
          className="table oecd-table"
        >
          <Thead>
            { this.renderThead() }
          </Thead>
          { this.renderTrs() }
        </Table>

        <DiversionModal
          content={ modalContent }
          show={ modalOpen }
          onClose={ this.handleCloseModal }
        />
      </div>
    );
  }
}

export default DiversionTable;



// WEBPACK FOOTER //
// ./src/components/Diversion/DiversionTable.js